import { apiErrorMessage } from '../apiErrorMessage.js';

export function authenticationErrorMessage(error: unknown): string {
	if (error && typeof error === 'object' && 'errorCode' in error && typeof error.errorCode === 'string') {
		const messages: Record<string, string> = {
			user_cancelled: 'Sign-in was cancelled. You can try again.',
			interaction_in_progress: 'Sign-in is already in progress. Complete the open sign-in window.',
			no_network_connectivity: 'Unable to reach the sign-in service. Check your connection and try again.',
			post_request_failed: 'Unable to reach the sign-in service. Please try again.',
			get_request_failed: 'Unable to reach the sign-in service. Please try again.',
			consent_required: 'Administrator approval is required for this application.',
		};
		return messages[error.errorCode] ?? 'Sign-in could not be completed. Please try again.';
	}
	return apiErrorMessage(error);
}
